import { HttpClient, HttpContext } from "@angular/common/http";

import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { CustomerService } from "@hermes/api-model-editorial";
import { Settings } from "@hermes/core-app-core";
import { SKIP_404_INTERCEPTOR } from "@hermes/utils-generic-constants";

@Injectable()
export class CustomerServiceContactService {
    private http = inject(HttpClient);
    private settings = inject(Settings);

    /**
     * Fetch customer service contact informations from the back-end
     */
    public fetchCustomerServiceContacts(): Observable<CustomerService[]> {
        const context = new HttpContext().set(SKIP_404_INTERCEPTOR, true);
        return this.http.get<CustomerService[]>(
            `${this.settings.apiUrl}/customer-service`,
            {
                context,
            },
        );
    }
}
